export default __webpack_public_path__ + "static/media/teabag.5daa7412.svg";